import { clearUser } from "../redux/users/usersSlice";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FiLogOut } from "react-icons/fi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

function LogoutButton() {
  const [showDropdown, setShowDropdown] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const handleSignOut = () => {
    dispatch(clearUser());
    navigate("/login");
  };

  return (
    <div>
      <button
        onClick={toggleDropdown}
        style={{
          backgroundColor: "transparent",
          border: "none",
          color: "#8E8E93",
          cursor: "pointer",
          outline: "none",
        }}
      >
        <FontAwesomeIcon icon={faCaretDown} />
      </button>
      {showDropdown && (
        <div
          style={{
            backgroundColor: "#064260",
            borderRadius: "20px",
            color: "#25BEFF",
            marginTop: "5px",
            padding: "10px",
            position: "absolute",
            right: "30px",
          }}
        >
          <button
            onClick={handleSignOut}
            style={{
              backgroundColor: "transparent",
              border: "none",
              color: "white",
              cursor: "pointer",
              display: "flex",
              fontSize: "15px",
              fontWeight: 500,
              gap: "8px",
            }}
          >
            <div>
              <FiLogOut />
            </div>
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
}

export default LogoutButton;
